import { Record, List, Map } from 'immutable';

export default class InquiryRecord extends Record({
  id: null,
  ad: new Map([
    ['enabled', false],
    ['header', undefined],
    ['description', undefined],
    ['publishedAt', undefined],
    ['user', undefined],
  ]),
  applicationsCount: null,
  availableWeekCount: null,
  availableWeeksString: null,
  comment: null,
  createdAt: null,
  createdBy: null,
  customer: null,
  dates: new List(),
  files: new List(),
  filled: false,
  filledRate: null,
  fromDate: null,
  inquiryDates: new List(),
  jobNeed: undefined,
  links: new List(),
  number: 1,
  period1: undefined,
  period2: undefined,
  period3: undefined,
  period4: undefined,
  period5: undefined,
  period6: undefined,
  period7: undefined,
  period8: undefined,
  services: new List(),
  tags: new List(),
  toDate: null,
  updatedAt: null,
  weekCount: null,
  weeksString: null,
}) {
}
